import get from 'lodash/get';
import { EditButton, EditButtonProps, useRecordContext } from 'react-admin';
export type SourceEditButtonProps = EditButtonProps & { source: string };

const SourceEditButton = (props: SourceEditButtonProps) => {
  const { source, ...rest } = props;
  let record = useRecordContext(props);
  if (!record) {
    return null;
  }
  if (source !== '') {
    record = get(record, source);
  }
  return <EditButton {...rest} record={record} />;
};

export default SourceEditButton;
